export default __webpack_public_path__ + "static/media/wallet-img.e224d7ea.png";